import React, { useState, useEffect, useMemo } from "react";
import {
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
  Label,
  Form,
  Button,
  Container,
  Row,
  Col,
  Table,
  Alert,
  Spinner,
  Card,
} from "reactstrap";

import { Line } from "react-chartjs-2";
import * as FaIcons from "react-icons/fa";
import axios from "axios";
import "../Bec/bec.scss";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import logos from "../../components/img/base/111.png";
import logos2 from "../../Pages/Admin/documentos/convocatoria/logo.jpeg";
import DefaultProfileImage from "../../components/img/base/Default.png"; // <-- Importa la imagen
import Swal from "sweetalert2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement);

// Colores definidos fuera del componente
const coloresPorAnio = [
  "rgba(255, 99, 132, 0.8)", // Rojo
  "rgba(54, 162, 235, 0.8)", // Azul
  "rgba(255, 206, 86, 0.8)", // Amarillo
  "rgba(75, 192, 192, 0.8)", // Verde
  "rgba(153, 102, 255, 0.8)", // Morado
  "rgba(255, 159, 64, 0.8)", // Naranja
  // Agrega más si es necesario
];

function ListUser() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [modalInsertar, setModalInsertar] = useState(false);
  const [modalEditar, setModalEditar] = useState(false);
  const [modalEliminar, setModalEliminar] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalGraduado, setModalGraduado] = useState(false);
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState({
    id: "",
    nombre: "",
    apellido: "",
    id_bec: "",
    anio_ing_bqef: "",
    ci_bec: "",
    exp_ci_bec: "",
    fec_nac_bec: "",
    edad_bec: "",
    nacio_bec: "",
    serv_mil_bec: "",
    celular: "",
    email: "",
    dir_bec: "",
    estado: "",
    contrasena_lit: "",
    inst_bec: "",
    tip_inst_bec: "",
    anio_grad_bec: "",
    prom_sec_bec: "",
    trab_col_bec: "",
    inst_sup_bec: "",
    dir_sup_bec: "",
    ciu_sup_bec: "",
    tip_sup_bec: "",
    pag_sup_bec: "",
    anio_sup_bec: "",
    matri_sup_bec: "",
    carr_sup_bec: "",
    semanio_sup_bec: "",
    xq_sup_bec: "",
    quien_sup_bec: "",
    dura_sup_bec: "",
    turn_sup_bec: "",
    dist_sup_bec: "",
    transp_sup_bec: "",
    pago_alq_bec: "",
    otrasact_sup_bec: "",
    nom_pad_bec: "",
    edad_pad_bec: "",
    tel_pad_bec: "",
    ocu_pad_bec: "",
    ins_pad_bec: "",
    act_pad_bec: "",
    hor_pad_bec: "",
    ing_pad_bec: "",
    nom_mad_bec: "",
    edad_mad_bec: "",
    tel_mad_bec: "",
    ocu_mad_bec: "",
    ins_mad_bec: "",
    act_mad_bec: "",
    hor_mad_bec: "",
    ing_mad_bec: "",
    vive_padres_bec: "",
    cvive_padres_bec: "",
    solo_bec: "",
    fam_casa_bec: "",
    fam_alq_bec: "",
    casa_alq_bec: "",
    ayu_bec: "",
    quie_ayu_bec: "",
    num_her_bec: "",
    muj_her_bec: "",
    var_her_bec: "",
    igle_nac_bec: "",
    jmen_bec: "",
    cdep_bec: "",
    dat_pas_bec: "",
    cel_pas_bec: "",
    cong_fam_bec: "",
    dsd_cong_bec: "",
    part_igle_bec: "",
    tipcarr_sup_bec: "",
    anio_egre_bqef: "",
    dias_a1: "",
    dias_b1: "",
    dias_c1: "",
    dias_d1: "",
    dias_e1: "",
    dias_f1: "",
    dias_g1: "",
    hor_a1: "",
    hor_a2: "",
    hor_a3: "",
    hor_b1: "",
    hor_b2: "",
    hor_b3: "",
    hor_c1: "",
    hor_c2: "",
    hor_c3: "",
    hor_d1: "",
    hor_d2: "",
    hor_d3: "",
    hor_e1: "",
    hor_e2: "",
    hor_e3: "",
    hor_f1: "",
    hor_f2: "",
    hor_f3: "",
    hor_g1: "",
    hor_g2: "",
    hor_g3: "",
    mat_a1: "",
    mat_b1: "",
    mat_c1: "",
    mat_d1: "",
    mat_e1: "",
    mat_f1: "",
    mat_g1: "",
    horario_anio: "",
    horario_semestre: "",

    // Agrega el campo para la foto de perfil
    foto: "", // O null, dependiendo de tu lógica inicial
  });
  // Definir un objeto de validación con patrones de expresiones regulares y estados de validación iniciales
  const validation = {
    nombre: { regex: /^[a-zA-Z\s]{1,20}$/, isValid: true },
    apellido: { regex: /^[a-zA-Z\s]{1,20}$/, isValid: true },
    id_bec: { regex: /^[a-zA-Z\s]{1,20}$/, isValid: true },
    anio_ing_bqef: { regex: /^\d{4,4}$/, isValid: true },
    email: {
      regex:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      isValid: false,
    },
    contrasena_lit: {
      regex:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%?&%"*#¡¿])[A-Za-z\d@$!%?&%"*#¡¿]{8,}$/,
      isValid: true,
    },
    celular: { regex: /^\d{8,8}$/, isValid: true },
  };

  const [isValid, setIsValid] = useState({
    nombre: true,
    apellido: true,
    id_bec: true,
    anio_ing_bqef: true,
    email: false,
    celular: true,
    contrasena_lit: true,
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUsuarioSeleccionado((prevState) => ({ ...prevState, [name]: value }));

    if (validation[name]) {
      const isValidValue = validation[name].regex.test(value);
      setIsValid((prevState) => ({ ...prevState, [name]: isValidValue }));
    } else {
      // Puedes decidir qué hacer si validation[name] no existe
      // Por ejemplo, marcar como válido o inválido, o simplemente ignorar
      setIsValid((prevState) => ({ ...prevState, [name]: true }));
    }
  };

  ///
  const abrirCerrarModalInsertar = () => {
    if (!modalInsertar) {
      limpiarCampos();
    }
    setModalInsertar(!modalInsertar);
  };
  ////limpiar modal
  const limpiarCampos = () => {
    setUsuarioSeleccionado({
      nombre: "",
      apellido: "",
      id_bec: "",
      email: "",
      contrasena_lit: "",
      celular: "",
    });
  };
  const closeBtnA = (
    <Button
      className="close"
      onClick={() => abrirCerrarModalInsertar()}
      style={{
        color: "white",
        position: "absolute",
        right: "10px",
        // top: "5%",
        // transform: "translateY(-50%)",
        // background: "none",
        // border: "none",
        // fontSize: "2rem",
      }}
      aria-label="Close"
    >
      {" "}
      &times;
    </Button>
  );

  const abrirCerrarModalEditar = () => {
    setModalEditar(!modalEditar);
  };
  ////modal
  const abrirCerrarModalVerPerfil = () => {
    setModalOpen(!modalOpen);
  };

  const abrirCerrarModalGraduado = () => {
    setModalGraduado(!modalGraduado);
  };

  const abrirCerrarModalEliminar = () => {
    setModalEliminar(!modalEliminar);
  };
  ////Modal REPORTE NOTAS
  const [modalVerNot, setModalVerNot] = useState(false);
  const abrirCerrarModalVerNot = () => {
    setModalVerNot(!modalVerNot);
  };
  const closeBtn2 = (
    <Button
      className="close"
      onClick={() => abrirCerrarModalVerNot()}
      style={{
        color: "white",
        position: "absolute",
        right: "10px",
      }}
    >
      &times;
    </Button>
  );

  const baseUrl = "https://bqef-bo.com/api/A/apiDash.php";
  ////Datos usuario Administrador
  const [dataAdm, setDataAdm] = useState({});

  const peticionGetAdm = async () => {
    setLoading(true);
    setError("");
    const adminId = sessionStorage.getItem("iduser");
    try {
      const res = await axios.get(`${baseUrl}?action=getInfoAdm&id=${adminId}`);
      const receivedData =
        res.data.InfoAdm && Array.isArray(res.data.InfoAdm)
          ? res.data.InfoAdm
          : [];
      // console.log(res.data);
      setDataAdm(receivedData);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ha ocurrido un error al cargar los datos.",
        footer: `Código de error: ${error.response.status}`,
      });
    }
  };

  /////Listado usuarios becarios
  const [data, setData] = useState([]);
  const peticionGet = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${baseUrl}?action=getResumen`);
      const receivedData =
        res.data.becarios && Array.isArray(res.data.becarios)
          ? res.data.becarios
          : [];
      // console.log(res.data);
      setTablaUsuarios(receivedData);
      setData(receivedData);
    } catch (error) {
      console.error(error);
      setError("Error al cargar los datos");
    } finally {
      setLoading(false);
    }
  };
  // Estado
  const [dataRes, setDataRes] = useState([]);

  // Función para obtener datos
  async function peticionResumenDatos() {
    try {
      const res = await axios.get(`${baseUrl}?action=getResumen`);
      // console.log("Datos recibidos:", res.data);
      setDataRes(res.data);
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    }
  }

  // Ejecutar al cargar
  useEffect(() => {
    peticionResumenDatos();
  }, []);
  ///funcion ver contraseña
  const [mostrarContrasena, setMostrarContrasena] = useState(false);
  const toggleMostrarContrasena = () => {
    setMostrarContrasena(!mostrarContrasena);
  };
  /////Crear Usuario becario
  async function peticionPost(e) {
    e.preventDefault();
    let fd = new FormData();
    fd.append("nombre", usuarioSeleccionado.nombre);
    fd.append("apellido", usuarioSeleccionado.apellido);
    fd.append("id_bec", usuarioSeleccionado.id_bec);
    fd.append("anio_ing_bqef", usuarioSeleccionado.anio_ing_bqef);
    fd.append("estado", usuarioSeleccionado.estado);
    fd.append("email", usuarioSeleccionado.email);
    fd.append("contrasena_lit", usuarioSeleccionado.contrasena_lit);
    fd.append("celular", usuarioSeleccionado.celular);

    // Acceder directamente a la primera posición del array
    if (Array.isArray(dataAdm) && dataAdm.length > 0 && dataAdm[0].id_adm) {
      const idAdm = dataAdm[0].id_adm;
      fd.append("usu_creacion", idAdm);
    } else {
      console.error("No se encontró id_adm");
      return; // Detener envío si no hay id_adm
    }

    try {
      // const res =
      await axios.post(`${baseUrl}?action=addBec`, fd);
      // console.log(res.data);
      mostrarAlertaN();
      peticionGet();
      abrirCerrarModalInsertar();
    } catch (error) {
      console.log(error.response?.data || error);
      mostrarAlertaError();
    }
  }
  /////Modificar Usuario becario
  const peticionPut = async () => {
    // Verifica que dataAdm tiene datos
    const idAdm =
      Array.isArray(dataAdm) && dataAdm.length > 0 ? dataAdm[0].id_adm : null;

    if (!idAdm) {
      console.error("No se encontró id_adm para modificar");
      return; // O maneja el error de otra forma
    }

    const dataToSend = {
      id_bec: usuarioSeleccionado.id_bec,
      nombre: usuarioSeleccionado.nombre,
      apellido: usuarioSeleccionado.apellido,
      email: usuarioSeleccionado.email,
      contrasena_lit: usuarioSeleccionado.contrasena_lit,
      celular: usuarioSeleccionado.celular,
      usu_modificacion: idAdm,
    };

    // console.log("id_bec:", usuarioSeleccionado.id_bec);
    // console.log("Datos a enviar:", dataToSend);

    try {
      const response = await axios.put(
        `${baseUrl}?action=updateBec`,
        dataToSend,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      console.log(response.data);

      // Actualizar datos en local si es necesario
      const dataNueva = [...data];
      dataNueva.forEach((Usuario) => {
        if (Usuario.id_bec === usuarioSeleccionado.id_bec) {
          Usuario.nombre = usuarioSeleccionado.nombre;
          Usuario.apellido = usuarioSeleccionado.apellido;
          Usuario.email = usuarioSeleccionado.email;
          Usuario.contrasena_lit = usuarioSeleccionado.contrasena_lit;
          Usuario.celular = usuarioSeleccionado.celular;
        }
      });
      setData(dataNueva);
      abrirCerrarModalEditar();
      mostrarAlertaU();
    } catch (error) {
      console.error("Error en peticionPut:", error);
    }
  };
  /////Eliminar Usuario becario
  async function peticionDelete(id_bec) {
    const idAdm =
      Array.isArray(dataAdm) && dataAdm.length > 0 ? dataAdm[0].id_adm : null;

    if (!idAdm) {
      console.error("No se encontró id_adm para eliminar");
      return;
    }

    try {
      const res = await axios.delete(
        `${baseUrl}?action=deleteBec&id_bec=${id_bec}&usu_modificacion=${idAdm}`,
      );
      abrirCerrarModalEliminar();
      peticionGet();
      mostrarAlertaD();
      console.log(res.data);
    } catch (error) {
      console.error("Error en peticionDelete:", error);
    }
  }

  /////Graduar Usuario
  const peticionGrad = async () => {
    // Verifica que dataAdm tiene datos
    const idAdm =
      Array.isArray(dataAdm) && dataAdm.length > 0 ? dataAdm[0].id_adm : null;

    if (!idAdm) {
      console.error("No se encontró id_adm para modificar");
      return; // O maneja el error de otra forma
    }

    const data = {
      id_bec: usuarioSeleccionado.id_bec,
      nombre: usuarioSeleccionado.nombre,
      apellido: usuarioSeleccionado.apellido,
      email: usuarioSeleccionado.email,
      tipcarr_sup_bec: usuarioSeleccionado.tipcarr_sup_bec,
      anio_ing_bqef: usuarioSeleccionado.anio_ing_bqef,
      igle_nac_bec: usuarioSeleccionado.igle_nac_bec,
      celular: usuarioSeleccionado.celular,
      patro_bec: usuarioSeleccionado.patro_bec,
      usu_modificacion: idAdm,
    };

    axios
      .post(`${baseUrl}?action=AdddGrad`, data, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => {
        console.log(response.data);
        abrirCerrarModalGraduado();
        mostrarAlertaN();
        peticionGet();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const seleccionarUsuario = (Usuario, caso) => {
    setUsuarioSeleccionado(Usuario);

    switch (caso) {
      case "Editar":
        abrirCerrarModalEditar();
        break;
      case "Eliminar":
        abrirCerrarModalEliminar();
        break;
      case "Perfil":
        abrirCerrarModalVerPerfil();
        break;
      case "Graduado":
        abrirCerrarModalGraduado();
        break;
      default:
        // Opcional: maneja un caso por defecto si 'caso' no coincide con ninguno
        console.warn("Caso no reconocido:", caso);
        break;
    }
  };

  useEffect(() => {
    peticionGet();
    peticionGetAdm();
  }, []);
  ////BARRA BUSQUEDA
  const [busqueda, setBusqueda] = useState("");
  const [tablaUsuarios, setTablaUsuarios] = useState([]);

  const handleChangeB = (e) => {
    setBusqueda(e.target.value);
    filtrar(e.target.value);
  };

  const filtrar = (terminoBusqueda) => {
    // Convert the search term to lowercase for case-insensitive comparison
    const searchTermLower = terminoBusqueda.toLowerCase();

    // Use the filter() method to filter the tableUsers array based on the search term
    const resultadosBusqueda = tablaUsuarios.filter(
      (elemento) =>
        elemento.nombre.toLowerCase().includes(searchTermLower) ||
        elemento.apellido.toLowerCase().includes(searchTermLower) ||
        elemento.id_bec.toString().toLowerCase().includes(searchTermLower) ||
        elemento.celular.toString().toLowerCase().includes(searchTermLower) ||
        elemento.email.toLowerCase().includes(searchTermLower),
    );

    // Set the data to the filtered array
    setData(resultadosBusqueda);
  };
  ////ALERTAS
  const mostrarAlertaN = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Nuevo usuario registrado correctamente.",
      timer: 5000,
      icon: "success",
    });
  };
  const mostrarAlertaU = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Usuario Modificado.",
      timer: 5000,
      icon: "info",
    });
  };
  const mostrarAlertaD = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Eliminado!",
      text: "Usuario Eliminado.",
      timer: 5000,
      icon: "success",
    });
  };
  const mostrarAlertaError = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Error!",
      text: "No se pudo registrar.",
      timer: 5000,
      icon: "error",
    });
  };
  //////Filtrar columnas
  const [sortField, setSortField] = useState(null);
  const [order, setOrder] = useState("asc");

  const handleSortingChange = (accessor) => {
    const sortOrder =
      accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);
  };
  const sortedData = React.useMemo(() => {
    if (!sortField) return data;
    const sorted = [...data].sort((a, b) => {
      if (a[sortField] < b[sortField]) return order === "asc" ? -1 : 1;
      if (a[sortField] > b[sortField]) return order === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [data, sortField, order]);
  ///
  // Función para generar y abrir en una ventana el PDF
  const generatePDFN = async () => {
    if (!selectedUser) {
      alert("Por favor, seleccione un usuario");
      return;
    }

    const doc = new jsPDF({ orientation: "portrait" });

    // Propiedades del documento
    doc.setProperties({
      title: "Historial Notas",
      author: "BQEF",
      subject: "Reporte de datos",
      keywords: "becarios, reporte, datos",
      creator: "jsPDF",
    });

    // Agregar logo si existe
    if (logos) {
      doc.addImage(logos, "PNG", 10, 10, 20, 10);
    }

    // Título principal
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    const title = "FONDO DE EDUCACION DE CUAQUEROS BOLIVIANOS";
    const titleWidth = doc.getTextWidth(title);
    const x = (doc.internal.pageSize.width - titleWidth) / 2;
    const y = 20;
    doc.text(title, x, y);
    doc.line(x, y + 1, x + titleWidth, y + 1);

    // Subtítulo
    const subtitle = "Historial Notas";
    const subtitleWidth = doc.getTextWidth(subtitle);
    const subtitleX = (doc.internal.pageSize.width - subtitleWidth) / 2;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    doc.text(subtitle, subtitleX, 30);

    // Fecha
    const fecha = new Date();
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const año = fecha.getFullYear();
    doc.setFontSize(9);
    doc.text(`Fecha: ${dia}/${mes}/${año}`, 10, 25);

    // Datos del usuario
    const usuario = uniqueUsers.find((u) => u.id_bec === selectedUser);
    if (!usuario) {
      alert("Usuario no encontrado");
      return;
    }
    // Texto "Usuario:"
    const usuarioText = "Usuario: Administrador Sistema";
    const usuarioWidth = doc.getTextWidth(usuarioText);
    const usuarioX = doc.internal.pageSize.width - usuarioWidth - 10;
    doc.setFont("helvetica", "bold");
    doc.text(usuarioText, usuarioX, 35);

    // Posición inicial para los datos
    let currentY = 40;
    // const margin = 10;
    // const pageHeight = doc.internal.pageSize.height;
    // const footerHeight = 15;
    // const availableHeight = pageHeight - footerHeight;

    // Datos de notas en formato tabla
    const usuarioNotas = filteredNotas.filter((n) => n.id_bec === selectedUser);
    const tableColumns = [
      { header: "N°", dataKey: "n" },
      { header: "Nombre Becario", dataKey: "nombre" },
      { header: "N. Académica", dataKey: "promedio_semestre" },
      { header: "Gestión", dataKey: "anio" },
      { header: "Semestre", dataKey: "semestre" },
      { header: "N. Evaluación", dataKey: "nota_eva" },
    ];

    // Filtrar y preparar filas
    const filasFiltradas = usuarioNotas.filter(
      (n) =>
        n.promedio_semestre != null &&
        n.promedio_semestre !== "" &&
        n.anio != null &&
        n.anio !== "" &&
        n.semestre != null &&
        n.semestre !== "" &&
        n.nota_eva != null &&
        n.nota_eva !== "",
    );

    const tableRows = filasFiltradas.map((nota, index) => ({
      n: index + 1,
      nombre: nota.nombre + " " + nota.apellido,
      promedio_semestre: nota.promedio_semestre,
      anio: nota.anio,
      semestre: nota.semestre,
      nota_eva: nota.nota_eva,
    }));

    // Dibujar la tabla
    await autoTable(doc, {
      startY: currentY,
      head: [tableColumns.map((col) => col.header)],
      body: tableRows.map((row) => Object.values(row)),
      styles: { fontSize: 10 },
      headStyles: { fontSize: 9, fillColor: [10, 49, 67] },
    });

    // Obtener la posición final después de la tabla
    if (doc.lastAutoTable && typeof doc.lastAutoTable.finalY === "number") {
      currentY = doc.lastAutoTable.finalY + 10;
    } else {
      currentY += 10; // por si acaso
    }

    // Agregar gráfico si existe
    const chartElement = document.getElementById("chartContainer");
    if (chartElement) {
      const canvas = await html2canvas(chartElement);
      const imgData = canvas.toDataURL("image/png");
      const imgWidth = 180;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      // Título del gráfico
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.text("Gráfico de Notas", 10, currentY);
      // Imagen del gráfico
      doc.addImage(imgData, "PNG", 10, currentY + 5, imgWidth, imgHeight);
      currentY += imgHeight + 10;
    }

    // Numeración de páginas
    const totalPages = doc.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.text(
        `Página ${i} de ${totalPages}`,
        10,
        doc.internal.pageSize.getHeight() - 10,
      );
    }

    // Output y mostrar
    const arrayBuffer = await doc.output("arraybuffer");
    const blob = new Blob([arrayBuffer], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  // Crear usuarios únicos
  const uniqueUsers = useMemo(() => {
    const seen = new Set();
    return (dataRes.notas || []).filter((item) => {
      if (item.id_bec && !seen.has(item.id_bec)) {
        seen.add(item.id_bec);
        return true;
      }
      return false;
    });
  }, [dataRes]);

  // Estado para usuario seleccionado
  const [selectedUser, setSelectedUser] = useState("");

  // Función para manejar selección
  const handleSelectUser = (e) => {
    setSelectedUser(e.target.value);
  };

  // Filtrar notas según usuario seleccionado
  const filteredNotas = React.useMemo(() => {
    if (!selectedUser) return [];
    return (dataRes.notas || []).filter((item) => item.id_bec === selectedUser);
  }, [dataRes, selectedUser]);

  const { labels, chartData, pointColors } = React.useMemo(() => {
    if (!selectedUser || filteredNotas.length === 0) {
      return { labels: [], chartData: [], pointColors: [] };
    }

    // Filtrar notas válidas
    const notasValidas = filteredNotas.filter(
      (nota) =>
        nota.promedio_semestre !== null &&
        nota.promedio_semestre !== undefined &&
        !isNaN(nota.promedio_semestre),
    );

    // Agrupar por año y semestre
    const agrupacionPorAnioSemestre = {};
    notasValidas.forEach((nota) => {
      const anio = nota.anio ?? "Sin año";
      const semestre = nota.semestre ?? "N/A"; // o puedes usar "Semestre 1", "Semestre 2" si tienes esa info
      const etiqueta = `${anio}(${semestre})`;
      // const etiqueta = `${anio} - Semestre ${semestre}`;
      if (!agrupacionPorAnioSemestre[etiqueta]) {
        agrupacionPorAnioSemestre[etiqueta] = [];
      }
      agrupacionPorAnioSemestre[etiqueta].push(nota.promedio_semestre);
    });

    // Ordenar las etiquetas si quieres un orden lógico
    const sortedEtiquetas = Object.keys(agrupacionPorAnioSemestre).sort(
      (a, b) => {
        // Puedes definir una lógica personalizada para ordenar, por ejemplo, por año
        const [anioA, semA] = a.split(" - ");
        const [anioB, semB] = b.split(" - ");
        // Ordenar por año numérico
        const anioNumA = parseInt(anioA) || 0;
        const anioNumB = parseInt(anioB) || 0;
        if (anioNumA !== anioNumB) {
          return anioNumA - anioNumB;
        }
        // Si los años son iguales, ordenar por semestre
        const semNumA = parseInt(semA) || 0;
        const semNumB = parseInt(semB) || 0;
        return semNumA - semNumB;
      },
    );

    const labelsArray = sortedEtiquetas;

    const dataArray = [];
    const colorArray = [];

    sortedEtiquetas.forEach((etiqueta, index) => {
      const notas = agrupacionPorAnioSemestre[etiqueta];
      notas.forEach((nota) => {
        dataArray.push(nota);
        const color = coloresPorAnio[index % coloresPorAnio.length];
        colorArray.push(color);
      });
    });

    return {
      labels: labelsArray,
      chartData: dataArray,
      pointColors: colorArray,
    };
  }, [filteredNotas, selectedUser]);

  // Configuración del gráfico
  const opcionesNotas = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "Tasa de crecimiento anual (%)",
        font: {
          size: 24, // tamaño de fuente grande
          weight: "bold", // opcional: hacer el título en negrita
        },
      },
    },
    scales: {
      y: {
        min: 0,
        max: 100,
        beginAtZero: true,
      },
    },
  };

  const datosNotas = {
    labels: labels,
    datasets: [
      {
        label: "Notas",
        data: chartData,
        borderColor: "rgba(49, 51, 124, 0.5)",
        backgroundColor: "rgba(49, 51, 124, 0.2)",
        fill: false,
        pointBackgroundColor: pointColors,
        pointBorderColor: "rgba(49, 51, 124, 0.5)",
        pointBorderWidth: 1,
        pointRadius: 8, // Aumenta el tamaño de los puntos
        pointHoverRadius: 12, // Aumenta tamaño en hover
        pointHoverBackgroundColor: "rgba(49, 51, 124, 0.4)",
        pointHoverBorderColor: "rgba(49, 51, 124, 0.7)",
      },
    ],
  };
  ///GENERAR PDF INFORME
  const generatePDF = () => {
    // Crear un nuevo documento PDF en orientación horizontal (landscape)
    const doc = new jsPDF({ orientation: "landscape" });

    // Propiedades del documento (puedes incluir título, autor, etc.)
    doc.setProperties({
      title: "Reporte Datos Becarios",
      author: "BQEF",
      subject: "Reporte de datos",
      keywords: "becarios, reporte, datos",
      creator: "jsPDF",
    });

    // Agregar logo al documento PDF
    doc.addImage(logos, "PNG", 10, 10, 20, 10);

    // Establecer la fuente en negrita
    doc.setFont("helvetica", "bold");

    // Agregar título "FONDO DE EDUCACIÓN" al documento PDF
    doc.setFontSize(12);
    const title = "FONDO DE EDUCACION DE CUAQUEROS BOLIVIANOS";
    const titleWidth = doc.getTextWidth(title);
    const x = (doc.internal.pageSize.width - titleWidth) / 2; // Calcular posición X para centrar
    const y = 20; // Posición Y del título

    // Escribir el título
    doc.text(title, x, y);

    // Dibujar la línea subrayando el título
    doc.line(x, y + 1, x + titleWidth, y + 1); // Dibuja la línea

    // Restablecer la fuente a normal
    doc.setFont("helvetica", "normal");

    // Agregar subtítulo "Reporte" al documento PDF
    const subtitle = "Reporte Datos Becarios";
    const subtitleWidth = doc.getTextWidth(subtitle);
    const subtitleX = (doc.internal.pageSize.width - subtitleWidth) / 2; // Calcular posición X para centrar
    doc.text(subtitle, subtitleX, 30);

    // Agregar fecha al documento PDF
    const fecha = new Date();
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const año = fecha.getFullYear();
    doc.setFontSize(9);
    doc.text(`Fecha: ${dia}/${mes}/${año}`, 10, 25);

    // Establecer la fuente en negrita
    doc.setFont("helvetica", "bold");

    // Definir el texto "Usuario: "
    const usuarioText = "Usuario: Administrador Sistema";

    // Calcular el ancho del texto
    const usuarioWidth = doc.getTextWidth(usuarioText);

    // Calcular la posición X para alinearlo a la derecha
    const usuarioX = doc.internal.pageSize.width - usuarioWidth - 10; // 10 mm de margen desde el borde derecho

    // Escribir el texto "Usuario:" en la posición calculada
    doc.text(usuarioText, usuarioX, 35);

    // Definir los datos de la tabla
    const userData = data
      .map((iteb) => ({
        nom_b: `${iteb.nombre} ${iteb.apellido}`,
        email: iteb.email,
        inst_sup_bec: iteb.inst_sup_bec,
        carr_sup_bec: iteb.carr_sup_bec,
        anio_sup_bec: iteb.anio_sup_bec,
        celular: iteb.celular,
        ciu_sup_bec: iteb.ciu_sup_bec,
        dir_bec: iteb.dir_bec,
        nom_pad_bec: iteb.nom_pad_bec,
        nom_mad_bec: iteb.nom_mad_bec,
      }))
      .sort((a, b) => a.nom_b.localeCompare(b.nom_b)) // Ordenar por nombre en orden alfabético ascendente
      .map((iteb, nb) => ({
        it: nb + 1, // Asignar el índice de forma ascendente después de ordenar
        ...iteb, // Desestructurar el resto de las propiedades
      }));

    // Definir las columnas de la tabla
    const columns = [
      { header: "N°", dataKey: "it" },
      { header: "Nombre Becario", dataKey: "nom_b" },
      { header: "Correo", dataKey: "email" },
      { header: "Institución", dataKey: "inst_sup_bec" },
      { header: "Carrera", dataKey: "carr_sup_bec" },
      { header: "Año", dataKey: "anio_sup_bec" },
      { header: "Telf/Cel", dataKey: "celular" },
      { header: "Ciudad", dataKey: "ciu_sup_bec" },
      { header: "Dirección", dataKey: "dir_bec" },
      { header: "Nombre Padre", dataKey: "nom_pad_bec" },
      { header: "Nombre Madre", dataKey: "nom_mad_bec" },
    ];

    // Restablecer la fuente a normal
    doc.setFont("helvetica", "normal");
    autoTable(doc, {
      columns: columns,
      body: userData,
      startY: 40,
      margin: { top: 20, bottom: 20 },
      styles: { fontSize: 8 },
      headStyles: { fontSize: 9, fillColor: [10, 49, 67] },
    });

    // Agregar número de página al documento PDF
    let totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.text(
        `Página ${i} de ${totalPages}`,
        10,
        doc.internal.pageSize.height - 10,
      );
    }

    // Convertir el documento PDF a blob
    const pdfBlob = doc.output("blob");

    // Abrir el PDF en una nueva ventana
    const url = URL.createObjectURL(pdfBlob);
    window.open(url, "_blank");
  };
  ////Generar horarios becarios
  const generateUserProfilePDF = () => {
    const doc = new jsPDF({ orientation: "portrait" });

    // Propiedades del documento
    doc.setProperties({
      title: "Reporte Horarios Becarios",
      author: "BQEF",
      subject: "Reporte de datos",
      keywords: "Horarios Becarios, reporte, datos",
      creator: "jsPDF",
    });

    // Agregar logo
    if (logos) {
      doc.addImage(logos, "PNG", 10, 10, 20, 10);
    }

    // Título principal
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    const title = "FONDO DE EDUCACION DE CUAQUEROS BOLIVIANOS";
    const titleWidth = doc.getTextWidth(title);
    const x = (doc.internal.pageSize.width - titleWidth) / 2;
    const y = 20;
    doc.text(title, x, y);
    doc.line(x, y + 1, x + titleWidth, y + 1);

    // Subtítulo
    const subtitle = "Reporte Horarios Becarios";
    const subtitleWidth = doc.getTextWidth(subtitle);
    const subtitleX = (doc.internal.pageSize.width - subtitleWidth) / 2;
    doc.text(subtitle, subtitleX, 30);

    // Fecha
    const fecha = new Date();
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const año = fecha.getFullYear();
    doc.setFontSize(9);
    doc.text(`Fecha: ${dia}/${mes}/${año}`, 10, 25);

    // Usuario
    doc.setFont("helvetica", "bold");
    const usuarioText = "Usuario: Administrador Sistema";
    const usuarioWidth = doc.getTextWidth(usuarioText);
    const usuarioX = doc.internal.pageSize.width - usuarioWidth - 10;
    doc.text(usuarioText, usuarioX, 35);

    // Datos principales
    let currentY = 40;
    const margin = 10;
    const pageHeight = doc.internal.pageSize.height;
    const footerHeight = 15;
    const availableHeight = pageHeight - footerHeight;

    // Iterar sobre usuarios
    data.forEach((usuario, index) => {
      // Estimación de altura para cada usuario
      const estimatedHeightForUser =
        15 +
        (usuario.horario_semestre ? 5 : 0) +
        (usuario.horario_semestre ? 5 : 0) +
        10;

      // Verificar si hay espacio en la página
      if (currentY + estimatedHeightForUser > availableHeight && index > 0) {
        doc.addPage();
        currentY = 10;
      }

      // Título del usuario
      doc.setFont("helvetica", "bold");
      doc.text(
        `Horario de ${usuario.nombre} ${usuario.apellido}`,
        margin,
        currentY,
      );
      currentY += 5;

      // Semestre/Año si existe
      if (usuario.horario_semestre) {
        doc.text(`Semestre/Año: ${usuario.horario_semestre}`, margin, currentY);
        currentY += 5;
      } else {
        currentY += 5;
      }

      // Columnas de la tabla
      const horarioColumns = [
        { header: "Día", dataKey: "dia" },
        { header: "Hora", dataKey: "hora" },
        { header: "Materia", dataKey: "materia" },
      ];

      // Construir array de horario para cada usuario
      const horarioUsuario = [];
      const isValidMateria = (materia) => {
        return (
          materia &&
          typeof materia === "string" &&
          materia.toLowerCase() !== "null"
        );
      };

      // Agregar filas si las materias son válidas
      if (isValidMateria(usuario.mat_a1)) {
        horarioUsuario.push({
          dia: usuario.dias_a1,
          hora: usuario.hor_a1,
          materia: usuario.mat_a1,
        });
      }
      if (isValidMateria(usuario.mat_b1)) {
        horarioUsuario.push({
          dia: usuario.dias_b1,
          hora: usuario.hor_b1,
          materia: usuario.mat_b1,
        });
      }
      if (isValidMateria(usuario.mat_c1)) {
        horarioUsuario.push({
          dia: usuario.dias_c1,
          hora: usuario.hor_c1,
          materia: usuario.mat_c1,
        });
      }
      if (isValidMateria(usuario.mat_d1)) {
        horarioUsuario.push({
          dia: usuario.dias_d1,
          hora: usuario.hor_d1,
          materia: usuario.mat_d1,
        });
      }
      if (isValidMateria(usuario.mat_e1)) {
        horarioUsuario.push({
          dia: usuario.dias_e1,
          hora: usuario.hor_e1,
          materia: usuario.mat_e1,
        });
      }
      if (isValidMateria(usuario.mat_f1)) {
        horarioUsuario.push({
          dia: usuario.dias_f1,
          hora: usuario.hor_f1,
          materia: usuario.mat_f1,
        });
      }
      if (isValidMateria(usuario.mat_g1)) {
        horarioUsuario.push({
          dia: usuario.dias_g1,
          hora: usuario.hor_g1,
          materia: usuario.mat_g1,
        });
      }
      // Agrega más si es necesario...

      // Si hay datos para la tabla
      if (horarioUsuario.length > 0) {
        autoTable(doc, {
          columns: horarioColumns, // en lugar de 'head'
          body: horarioUsuario,
          startY: currentY,
          margin: { left: margin, right: 10 },
          styles: { fontSize: 9 },
          headStyles: { fontSize: 10, fillColor: [10, 49, 67] },
        });
        // Actualizar currentY usando lastAutoTable.finalY
        if (doc.lastAutoTable && typeof doc.lastAutoTable.finalY === "number") {
          currentY = doc.lastAutoTable.finalY + 10;
        } else {
          // fallback
          currentY += 10;
        }
      } else {
        // Sin datos, dejar espacio
        currentY += 10;
      }
    });

    // Agregar numeración de páginas
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.text(
        `Página ${i} de ${totalPages}`,
        10,
        doc.internal.pageSize.height - 10,
      );
    }

    // Mostrar el PDF en una nueva ventana
    const pdfBlob = doc.output("blob");
    const url = URL.createObjectURL(pdfBlob);
    window.open(url, "_blank");
  };

  // Determina la fuente de la imagen
  const imageUrl = usuarioSeleccionado.foto
    ? `data:image/png;base64,${usuarioSeleccionado.foto}` // Si hay datos en usuarioSeleccionado.foto, úsalos como Base64
    : DefaultProfileImage; // Si no, usa la imagen por defecto importada
  // ==========================
  // Función para generar el PDF
  // ==========================
  const generatePDFPerfil = (usuario) => {
    // Usa los datos del usuario directamente, por ejemplo:
    // console.log("Generando PDF con usuario:", usuario);
    const doc = new jsPDF({ orientation: "portrait" });
    const pageWidth = doc.internal.pageSize.getWidth();

    // Función para verificar espacio y agregar página si es necesario
    const ensureSpace = (doc, currentY, spaceNeeded) => {
      const pageHeight = doc.internal.pageSize.getHeight();
      const marginBottom = 20; // margen inferior
      if (currentY + spaceNeeded > pageHeight - marginBottom) {
        doc.addPage();
        return 20; // posición inicial en la nueva página
      }
      return currentY;
    };

    // Propiedades del documento (puedes incluir título, autor, etc.)
    doc.setProperties({
      title: "Formulario de Solicitud de Beca",
      author: "BQEF",
      subject: "Formulario de datos",
      keywords: "becario, formulario, datos",
      creator: "jsPDF",
    });

    // ==============================
    // 1. CABECERA: Título, fecha e imágenes
    // ==============================
    const logoWidth = 30;
    const logoHeight = 30;
    const marginTop = 10;

    // Imagen izquierda
    if (logos2) {
      doc.addImage(logos2, "JPEG", 10, marginTop + 5, logoWidth, logoHeight);
    }
    // Puedes agregar otra imagen a la derecha si quieres
    const margin2Top = 35;
    // Define las coordenadas y dimensiones
    const x = pageWidth - logoWidth - 10;
    const y = margin2Top;
    // Opcional: margen en píxeles para el borde negro
    const borderMargin = 2; // ajusta este valor para el grosor del borde
    // Define el grosor del borde si quieres
    // La línea por defecto suele ser de 0.2 mm, pero puedes ajustarla
    doc.setLineWidth(0.5); // opcional, ajusta según tu preferencia

    // Configura el color del borde a negro
    doc.setDrawColor(0, 0, 0);

    // Dibuja solo el borde (sin relleno)
    doc.rect(
      x - borderMargin,
      y - borderMargin,
      logoWidth + 2 * borderMargin,
      logoHeight + 2 * borderMargin,
    );

    // Agrega la imagen encima del borde
    doc.addImage(imageUrl, "PNG", x, y, logoWidth, logoHeight);

    // --- Título centrado "Fundación Cuáquera para la Educación en Bolivia" ---
    const mainTitle = "Fundación Cuáquera para la Educación en Bolivia"; // Tu título principal
    const titleFontSize = 12;
    doc.setFontSize(titleFontSize);
    const titleWidth = doc.getTextWidth(mainTitle);
    const titleX = (pageWidth - titleWidth) / 2;
    const titleY = marginTop + logoHeight / 2 + 4;

    // Dibujar el título principal
    doc.text(mainTitle, titleX, titleY);

    // Línea debajo del título principal
    doc.setLineWidth(0.5);
    doc.line(titleX, titleY + 1, titleX + titleWidth, titleY + 1);

    // --- Añadir el título "Programa de Becas 2013" con línea subrayada debajo ---
    const subTitle1 = "Programa de Becas 2013";
    const subTitle1Size = 12;
    doc.setFontSize(subTitle1Size);
    const subTitle1Width = doc.getTextWidth(subTitle1);
    const subTitle1X = (pageWidth - subTitle1Width) / 2;
    const subTitle1Y = titleY + 7; // Espacio debajo del título principal, ajusta si es necesario

    // Dibujar el título "Programa de Becas 2013"
    doc.text(subTitle1, subTitle1X, subTitle1Y);

    // Línea subrayada debajo del "Programa de Becas 2013"
    doc.setLineWidth(0.5);
    doc.line(
      subTitle1X,
      subTitle1Y + 1,
      subTitle1X + subTitle1Width,
      subTitle1Y + 1,
    );

    // --- Añadir el segundo título "Formulario de Solicitud de Beca" sin subrayado ---
    const subTitle2 = "Formulario de Solicitud de Beca";
    const subTitle2Size = 12;
    doc.setFontSize(subTitle2Size);
    const subTitle2Width = doc.getTextWidth(subTitle2);
    const subTitle2X = (pageWidth - subTitle2Width) / 2;
    const subTitle2Y = subTitle1Y + 15; // Espacio debajo del primer subtítulo

    // Dibujar "Formulario de Solicitud de Beca"
    doc.text(subTitle2, subTitle2X, subTitle2Y);

    // --- Posicionar la fecha en la esquina superior izquierda ---
    const fecha = new Date();
    const dia = fecha.getDate().toString().padStart(2, "0");
    const mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
    const año = fecha.getFullYear();
    const fechaTexto = `Fecha: ${dia}/${mes}/${año}`;

    // Posición en la esquina superior izquierda
    const fechaX = marginTop;
    const fechaY = marginTop + 4; // Ajusta si quieres más espacio

    // Dibujar la fecha
    doc.setFontSize(9);
    doc.text(fechaTexto, fechaX, fechaY);

    // Control de posición vertical
    let currentY = subTitle2Y + 15;

    // ==============================
    // Función para agregar sección con subtítulo y tabla
    // ==============================
    const addSection = (subtitle, data) => {
      currentY = ensureSpace(doc, currentY, 20);
      // Si se agregó página, reiniciar currentY a posición inicial
      if (currentY === 20) {
        // Opcional: agregar un pequeño margen
      }
      // Añadir subtítulo centrado
      doc.setFontSize(10);
      doc.setFont("Helvetica", "bold");
      currentY = Math.max(ensureSpace(doc, currentY, 20), currentY);
      doc.text(subtitle, 10, currentY);
      currentY += 4;

      // Añadir tabla
      const startY = currentY;
      autoTable(doc, {
        startY: startY,
        head: [["Descripción", "Dato", "Descripción", "Dato"]],
        body: data.map((row) => [row.campo, row.valor, row.info3, row.info4]),
        styles: { fontSize: 10 },
        headStyles: { fillColor: [10, 49, 67] },
        margin: { left: 10, right: 10 },
      });

      // Actualizar currentY usando la posición final de la tabla
      currentY = doc.lastAutoTable.finalY + 4;
    };
    // Datos de ejemplo - ajusta según tus datos
    const {
      nombre,
      apellido,
      ci_bec,
      exp_ci_bec,
      fec_nac_bec,
      edad_bec,
      nacio_bec,
      serv_mil_bec,
      celular,
      email,
      dir_bec,
      inst_bec,
      tip_inst_bec,
      anio_grad_bec,
      prom_sec_bec,
      trab_col_bec,
      inst_sup_bec,
      dir_sup_bec,
      tip_sup_bec,
      pag_sup_bec,
      anio_sup_bec,
      matri_sup_bec,
      carr_sup_bec,
      semanio_sup_bec,
      xq_sup_bec,
      quien_sup_bec,
      dura_sup_bec,
      turn_sup_bec,
      dist_sup_bec,
      transp_sup_bec,
      pago_alq_bec,
      otrasact_sup_bec,
      nom_pad_bec,
      edad_pad_bec,
      tel_pad_bec,
      ocu_pad_bec,
      ins_pad_bec,
      act_pad_bec,
      hor_pad_bec,
      ing_pad_bec,
      nom_mad_bec,
      edad_mad_bec,
      tel_mad_bec,
      ocu_mad_bec,
      ins_mad_bec,
      act_mad_bec,
      hor_mad_bec,
      ing_mad_bec,
      vive_padres_bec,
      cvive_padres_bec,
      solo_bec,
      fam_casa_bec,
      fam_alq_bec,
      casa_alq_bec,
      ayu_bec,
      quie_ayu_bec,
      num_her_bec,
      muj_her_bec,
      var_her_bec,
      igle_nac_bec,
      jmen_bec,
      cdep_bec,
      dat_pas_bec,
      cel_pas_bec,
      cong_fam_bec,
      dsd_cong_bec,
      part_igle_bec,
    } = usuario;
    const datosPersonales = [
      {
        campo: "Apellido(s):",
        valor: `${apellido}`,
        info3: "Nombre(s):",
        info4: `${nombre}`,
      },
      { campo: "CI:", valor: ci_bec, info3: "Espedido:", info4: exp_ci_bec },
      {
        campo: "Fecha Nacimiento:",
        valor: fec_nac_bec,
        info3: "Edad:",
        info4: edad_bec,
      },
      {
        campo: "Nacionalidad:",
        valor: nacio_bec,
        info3: "Año Serv. Militar:",
        info4: serv_mil_bec,
      },
      { campo: "Celular:", valor: celular, info3: "Email:", info4: email },
      { campo: "Dirección:", valor: dir_bec, info3: "", info4: "" },
    ];

    const datosCentroEstudios = [
      {
        campo: "Institución Educativa:",
        valor: inst_bec,
        info3: "Tipo Institución:",
        info4: tip_inst_bec,
      },
      {
        campo: "¿En qué año te graduaste del colegio?:",
        valor: anio_grad_bec,
        info3:
          "¿Cuál es el promedio de calificaciones que obtuviste en 6to. de secudaria?:",
        info4: prom_sec_bec,
      },
      {
        campo: "Despues de graduarte de colegio, ¿qué actividades realizaste?:",
        valor: trab_col_bec,
        info3: "",
        info4: "",
      },
    ];

    const datosEstudioSuperior = [
      {
        campo: "Institución Educación Superior:",
        valor: inst_sup_bec,
        info3: "Dirección:",
        info4: dir_sup_bec,
      },
      {
        campo: "Tipo Institución:",
        valor: tip_sup_bec,
        info3: "Mensualidad:",
        info4: pag_sup_bec,
      },
      {
        campo: "Año Ingreso a la Institución:",
        valor: anio_sup_bec,
        info3: "N° Matrícula:",
        info4: matri_sup_bec,
      },
      {
        campo: "Carrera:",
        valor: carr_sup_bec,
        info3: "Semestre/Año que cursa",
        info4: semanio_sup_bec,
      },
      {
        campo: "¿Por qué decidio estudiar esa carrera?:",
        valor: xq_sup_bec,
        info3:
          "¿Quién/es o cómo han sido cubierto sus gastos de estudio hasta el momento?:",
        info4: quien_sup_bec,
      },
      {
        campo: "¿Cuántos semestres o años de estudio es la carrera?:",
        valor: dura_sup_bec,
        info3: "Turno de Estudio:",
        info4: turn_sup_bec,
      },
      {
        campo: "Distancia de casa a la Institución de estudio:",
        valor: dist_sup_bec,
        info3: "¿Por qué medio se traslada a la Institucion donde estudia?:",
        info4: transp_sup_bec,
      },
      {
        campo:
          "Si tiene un cuarto alquilado a causa de su estudio, ¿cuánto paga mensulamente?:",
        valor: pago_alq_bec,
        info3: "¿Qué otras actividades realizas fuera de tu estudio?(detallar)",
        info4: otrasact_sup_bec,
      },
    ];

    const datosFamilia = [
      {
        campo: "Apellido(s) y Nombre(s) del Padre:",
        valor: nom_pad_bec,
        info3: "Edad:",
        info4: edad_pad_bec,
      },
      {
        campo: "Celular:",
        valor: tel_pad_bec,
        info3: "Profesión:",
        info4: ocu_pad_bec,
      },
      {
        campo: "institución de Trabajo:",
        valor: ins_pad_bec,
        info3: "Actividad/es que realiza:",
        info4: act_pad_bec,
      },
      {
        campo: "¿Cuántas horas al día trabaja?:",
        valor: hor_pad_bec,
        info3:
          "¿Con cuánto de ingreso económico mensual sostiene a la familia?:",
        info4: ing_pad_bec,
      },
      {
        campo: "Apellido(s) y Nombre(s) del Madre:",
        valor: nom_mad_bec,
        info3: "Edad:",
        info4: edad_mad_bec,
      },
      {
        campo: "Celular:",
        valor: tel_mad_bec,
        info3: "Profesión:",
        info4: ocu_mad_bec,
      },
      {
        campo: "institución de Trabajo:",
        valor: ins_mad_bec,
        info3: "Actividad/es que realiza:",
        info4: act_mad_bec,
      },
      {
        campo: "¿Cuántas horas al día trabaja?:",
        valor: hor_mad_bec,
        info3:
          "¿Con cuánto de ingreso económico mensual sostiene a la familia?:",
        info4: ing_mad_bec,
      },
      {
        campo: "¿Dónde viven actualmente sus padres?:",
        valor: vive_padres_bec,
        info3: "¿Con quién/es vive actualmente usted?:",
        info4: cvive_padres_bec,
      },
      {
        campo:
          "Y si vive solo/a, lejos de su familia describa, ¿en qué condiciones vive usted y por qué?:",
        valor: solo_bec,
        info3: "¿Su familia tiene casa propia?:",
        info4: fam_casa_bec,
      },
      {
        campo:
          "Si la respuesta es NO:¿Su familia y usted viven en un cuarto o casa en alquiler?:",
        valor: fam_alq_bec,
        info3: "¿Cuánto paga mensualmente por el cuarto o casa?:",
        info4: casa_alq_bec,
      },
      {
        campo:
          "¿Alguien de su familia recibió la ayuda de la Fundación Quakera para la Educación en Bolivia?:",
        valor: ayu_bec,
        info3: "¿Quién fue o quiénes fueron?:",
        info4: quie_ayu_bec,
      },
      {
        campo: "Nº Total de Hermanos/as:",
        valor: num_her_bec,
        info3: "Nº Mujeres:",
        info4: muj_her_bec,
      },
      {
        campo: "Nº Varones:",
        valor: var_her_bec,
        info3: "",
        info4: "",
      },
      {
        campo: "Apellidos y Nombre(s) de los hermanos:",
        valor: "1. ",
        info3: "Actividad que realiza (especificar):",
        info4: "1. ",
      },
      {
        campo: "",
        valor: "2. ",
        info3: "",
        info4: "2. ",
      },
      {
        campo: "",
        valor: "3. ",
        info3: "",
        info4: "3. ",
      },
      {
        campo: "",
        valor: "4. ",
        info3: "",
        info4: "4. ",
      },
    ];
    const datosCongre = [
      {
        campo: "Iglesia Nacional:",
        valor: igle_nac_bec,
        info3: "Junta Mensual:",
        info4: jmen_bec,
      },
      {
        campo: "Congregación Dependiente:",
        valor: cdep_bec,
        info3: "Apellidos y nombre(s) del Pastor:",
        info4: dat_pas_bec,
      },
      {
        campo: "Celular:",
        valor: cel_pas_bec,
        info3: "Apellidos y nombre(s) del Pastor:",
        info4: dat_pas_bec,
      },
      {
        campo: "¿Con quiénes de su familia se congrega?:",
        valor: cong_fam_bec,
        info3: "¿Desde cuándo se congrega y por qué?:",
        info4: dsd_cong_bec,
      },
      {
        campo: "Describa su participación actual en la Iglesia:",
        valor: part_igle_bec,
        info3: "",
        info4: "",
      },
    ];

    // ==============================
    // Agregar secciones en orden
    // ==============================
    addSection(" I. INFORMACION DE DATOS PERSONALES:", datosPersonales);
    addSection(" II. FORMACION PRIMARIA Y SECUNDARIA", datosCentroEstudios);
    addSection(
      " III. PROCESO DE FORMACION EN EDUCACION SUPERIOR",
      datosEstudioSuperior,
    );
    addSection(" IV. DATOS DE LA FAMILIA", datosFamilia);
    addSection(" V. DATOS DE SU CONGREGACION", datosCongre);

    // ==============================
    // Posición inicial para contenido
    // ==============================
    const marginLeft = 10;
    const availableHeight = doc.internal.pageSize.getHeight() - 20; // margen inferior para pie de página

    // Función auxiliar para concatenar horas (como en el modal original)
    const getHoras = (hor1, hor2, hor3) => {
      const horas = [hor1, hor2, hor3].filter((h) => h && h !== "null");
      return horas.join(" - ");
    };

    // Función para construir la lista de horarios (corregida para usar campos correctos del modal)
    const construirHorario = (usuario) => {
      const horarios = [];
      // Usar los campos correctos: dias_a1, mat_a1, etc., y concatenar horas
      const materias = [
        {
          materia: usuario.mat_a1,
          dia: usuario.dias_a1,
          horas: getHoras(usuario.hor_a1, usuario.hor_a2, usuario.hor_a3),
        },
        {
          materia: usuario.mat_b1,
          dia: usuario.dias_b1,
          horas: getHoras(usuario.hor_b1, usuario.hor_b2, usuario.hor_b3),
        },
        {
          materia: usuario.mat_c1,
          dia: usuario.dias_c1,
          horas: getHoras(usuario.hor_c1, usuario.hor_c2, usuario.hor_c3),
        },
        {
          materia: usuario.mat_d1,
          dia: usuario.dias_d1,
          horas: getHoras(usuario.hor_d1, usuario.hor_d2, usuario.hor_d3),
        },
        {
          materia: usuario.mat_e1,
          dia: usuario.dias_e1,
          horas: getHoras(usuario.hor_e1, usuario.hor_e2, usuario.hor_e3),
        },
        {
          materia: usuario.mat_f1,
          dia: usuario.dias_f1,
          horas: getHoras(usuario.hor_f1, usuario.hor_f2, usuario.hor_f3),
        },
        {
          materia: usuario.mat_g1,
          dia: usuario.dias_g1,
          horas: getHoras(usuario.hor_g1, usuario.hor_g2, usuario.hor_g3),
        },
      ];

      // Filtrar solo las materias válidas (no null o "null")
      materias.forEach(({ materia, dia, horas }) => {
        if (materia && materia !== "null") {
          horarios.push({ materia, dia, horas });
        }
      });
      return horarios;
    };

    // Función para agregar una sección con título y tabla (adaptada para tabla más grande y correcta)
    const agregarSeccionHorario = (usuario) => {
      // Estimación de altura aumentada para tabla más grande
      const estimatedHeight =
        20 +
        (usuario.horario_semestre ? 8 : 0) +
        (construirHorario(usuario).length > 0
          ? 15 + construirHorario(usuario).length * 10 // Aumentado para filas más altas
          : 0);

      // Ver si hay espacio en la página actual, si no, agregar página
      if (currentY + estimatedHeight > availableHeight) {
        doc.addPage();
        currentY = 20; // reiniciar posición en nueva página
      }

      // Título del horario
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.text(
        `Horario de ${usuario.nombre} ${usuario.apellido}`,
        marginLeft,
        currentY,
      );
      currentY += 6;

      // Semestre/Año si existe
      if (usuario.horario_semestre) {
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text(
          `Semestre/Año: ${usuario.horario_semestre}`,
          marginLeft,
          currentY,
        );
        currentY += 6;
      }

      // Construir datos del horario
      const horarioData = construirHorario(usuario);

      if (horarioData.length > 0) {
        // Dibujar la tabla con columnas como en el modal: Materia, Día, Hora
        // Aumentar el tamaño de la tabla ajustando estilos (fontSize mayor, cellPadding mayor)
        autoTable(doc, {
          head: [["Materia", "Día", "Hora"]],
          body: horarioData.map((item) => [item.materia, item.dia, item.horas]),
          startY: currentY,
          margin: { left: marginLeft, right: 10 },
          styles: { fontSize: 10, cellPadding: 5 }, // Aumentado para tabla más grande
          headStyles: { fillColor: [10, 49, 67] },
          columnStyles: {
            0: { cellWidth: 60 }, // Ancho fijo para Materia
            1: { cellWidth: 40 }, // Ancho fijo para Día
            2: { cellWidth: "auto" }, // Hora ajusta automáticamente
          },
        });
        // Actualizar currentY usando la posición final de la tabla
        currentY = doc.lastAutoTable.finalY + 10;
      } else {
        // Si no hay horarios, dejar espacio
        currentY += 10;
      }
    };

    // ==============================
    // Aquí llamamos a la función para cada usuario
    // ==============================
    agregarSeccionHorario(usuario);

    // ==============================
    // Número de páginas
    // ==============================
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.text(
        `Página ${i} de ${totalPages}`,
        10,
        doc.internal.pageSize.getHeight() - 10,
      );
    }

    // Mostrar en ventana
    const pdfBlob = doc.output("blob");
    const url = URL.createObjectURL(pdfBlob);
    window.open(url, "_blank");
  };

  /////
  const handleVerClick = (usuario) => {
    // console.log("Usuario para generar PDF:", usuario);
    generatePDFPerfil(usuario);
  };
  ////Carga
  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner color="primary" />
        Cargando...
      </div>
    );
  }

  if (error) {
    return <Alert color="danger">{error}</Alert>;
  }
  return (
    <div id="main_content">
      <div className="tra">
        <div className="tra title-form">
          <h2>Listado Becarios</h2>
        </div>
        <div className="frm">
          <Button
            color="success"
            size="lg"
            onClick={() => abrirCerrarModalInsertar()}
          >
            <FaIcons.FaPlus /> Añadir
          </Button>
          &nbsp;&nbsp;
          <Button color="primary" size="lg" onClick={generatePDF}>
            <FaIcons.FaFileDownload /> Reporte
          </Button>
          &nbsp;&nbsp;
          {/* Otros elementos de tu componente */}
          <Button color="secondary" size="lg" onClick={generateUserProfilePDF}>
            <FaIcons.FaFileDownload /> Horarios
          </Button>
          &nbsp;&nbsp;
          <Button
            color="secondary"
            size="lg"
            onClick={() => abrirCerrarModalVerNot()}
          >
            <FaIcons.FaAddressBook /> Notas
          </Button>
        </div>

        <div className="frm containerInput">
          <Input
            className="form-control inputBuscar"
            bsSize="lg" // cambia size por bsSize
            value={busqueda}
            placeholder="Búsqueda por Nombre, Apellido o Email"
            onChange={handleChangeB}
          />
          <Button color="success" size="lg">
            <FaIcons.FaSearch /> Buscar
          </Button>
        </div>

        <Table className="frm" responsive="sm" id="tabl">
          <thead id="stahead">
            <tr className="text-center">
              <th>N°</th>
              <th>
                <span onClick={() => handleSortingChange("nombre")}>
                  Nombres
                  {sortField === "nombre" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "nombre" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("apellido")}>
                  Apellidos
                  {sortField === "apellido" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "apellido" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("id_bec")}>
                  ID Usuario
                  {sortField === "id_bec" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "id_bec" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("email")}>
                  Correo
                  {sortField === "email" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "email" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("contrasena_lit")}>
                  Clave
                  {sortField === "contrasena_lit" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "contrasena_lit" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("celular")}>
                  Celular
                  {sortField === "celular" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "celular" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((Usuario, index) => (
              <tr className="text-center" key={index}>
                <td>{index + 1}</td>
                <td>{Usuario.nombre}</td>
                <td>{Usuario.apellido}</td>
                <td>{Usuario.id_bec}</td>
                <td>{Usuario.email}</td>
                <td>{Usuario.contrasena_lit}</td>
                <td>{Usuario.celular}</td>
                <td>
                  <Button
                    color="primary"
                    onClick={() => seleccionarUsuario(Usuario, "Perfil")}
                  >
                    Ver Perfil
                  </Button>{" "}
                  {"  "}
                  <Button
                    color="warning"
                    onClick={() => seleccionarUsuario(Usuario, "Editar")}
                  >
                    Editar
                  </Button>{" "}
                  {"  "}
                  <Button
                    color="danger"
                    onClick={() => seleccionarUsuario(Usuario, "Eliminar")}
                  >
                    Eliminar
                  </Button>{" "}
                  {"  "}
                  <Button
                    color="success"
                    onClick={() => seleccionarUsuario(Usuario, "Graduado")}
                  >
                    Graduado
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {/* El Modal REPORTE */}
        <Modal isOpen={modalOpen} toggle={abrirCerrarModalVerPerfil} size="lg">
          {" "}
          {/* size="lg" para un modal más grande */}
          <ModalHeader className="header_mo">Perfil de Usuario</ModalHeader>
          <ModalBody>
            <Container>
              <Row className="align-items-center">
                {" "}
                {/* Centrar verticalmente */}
                <Col md="4" className="text-center">
                  {/* Foto de Perfil - Usa usuarioSeleccionado.foto */}
                  <img
                    src={imageUrl} // Usa la fuente determinada
                    alt="Foto de Perfil"
                    className="rounded-circle"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }} // Estilo para tamaño y ajuste
                  />
                </Col>
                <Col md="8">
                  {/* Datos Principales */}
                  <h5>
                    <strong>Nombre Completo:</strong>{" "}
                    {usuarioSeleccionado.nombre} {usuarioSeleccionado.apellido}
                    <br />
                    <strong>Correo:</strong> {usuarioSeleccionado.email}
                    <br />
                    <strong>Institución:</strong>{" "}
                    {usuarioSeleccionado.inst_sup_bec}
                    <br />
                    <strong>Carrera:</strong> {usuarioSeleccionado.carr_sup_bec}
                    <br />
                    <strong>Año:</strong> {usuarioSeleccionado.horario_anio}
                    <br />
                    <strong>Semestre:</strong>{" "}
                    {usuarioSeleccionado.horario_semestre}
                    <br />
                    <strong>Teléfono/Celular:</strong>{" "}
                    {usuarioSeleccionado.celular}
                    <br />
                    <strong>Ciudad:</strong> {usuarioSeleccionado.ciu_sup_bec}
                    <br />
                    <strong>Dirección:</strong> {usuarioSeleccionado.dir_bec}
                    <br />
                    <strong>Nombre del Padre:</strong>{" "}
                    {usuarioSeleccionado.nom_pad_bec}
                    <br />
                    <strong>Nombre de la Madre:</strong>{" "}
                    {usuarioSeleccionado.nom_mad_bec}
                  </h5>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  {/* Horario Escolar en una Tabla */}
                  <Table className="frm" responsive="sm" id="tabl">
                    <thead id="stahead">
                      <tr>
                        <th>Materia</th>
                        <th>Día</th>
                        <th>Hora</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* Fila A */}
                      {usuarioSeleccionado.mat_a1 &&
                        usuarioSeleccionado.mat_a1 !== "null" && (
                          <tr>
                            <td>{usuarioSeleccionado.mat_a1}</td>
                            <td>{usuarioSeleccionado.dias_a1}</td>
                            <td>
                              {/* Mostrar hor_a1 solo si tiene un valor válido */}
                              {usuarioSeleccionado.hor_a1 &&
                                usuarioSeleccionado.hor_a1 !== "null" &&
                                usuarioSeleccionado.hor_a1}

                              {/* Mostrar separador si hor_a1 tiene valor Y hor_a2 tiene valor */}
                              {usuarioSeleccionado.hor_a1 &&
                                usuarioSeleccionado.hor_a1 !== "null" &&
                                usuarioSeleccionado.hor_a2 &&
                                usuarioSeleccionado.hor_a2 !== "null" &&
                                " - "}

                              {/* Mostrar hor_a2 solo si tiene un valor válido */}
                              {usuarioSeleccionado.hor_a2 &&
                                usuarioSeleccionado.hor_a2 !== "null" &&
                                usuarioSeleccionado.hor_a2}

                              {/* Mostrar separador si (hor_a1 O hor_a2 tienen valor) Y hor_a3 tiene valor */}
                              {((usuarioSeleccionado.hor_a1 &&
                                usuarioSeleccionado.hor_a1 !== "null") ||
                                (usuarioSeleccionado.hor_a2 &&
                                  usuarioSeleccionado.hor_a2 !== "null")) &&
                                usuarioSeleccionado.hor_a3 &&
                                usuarioSeleccionado.hor_a3 !== "null" &&
                                " - "}

                              {/* Mostrar hor_a3 solo si tiene un valor válido */}
                              {usuarioSeleccionado.hor_a3 &&
                                usuarioSeleccionado.hor_a3 !== "null" &&
                                usuarioSeleccionado.hor_a3}
                            </td>
                          </tr>
                        )}

                      {/* Fila B */}
                      {usuarioSeleccionado.mat_b1 &&
                        usuarioSeleccionado.mat_b1 !== "null" && (
                          <tr>
                            <td>{usuarioSeleccionado.mat_b1}</td>
                            <td>{usuarioSeleccionado.dias_b1}</td>
                            <td>
                              {/* Mostrar hor_b1 solo si tiene un valor válido */}
                              {usuarioSeleccionado.hor_b1 &&
                                usuarioSeleccionado.hor_b1 !== "null" &&
                                usuarioSeleccionado.hor_b1}

                              {/* Mostrar separador si hor_b1 tiene valor Y hor_b2 tiene valor */}
                              {usuarioSeleccionado.hor_b1 &&
                                usuarioSeleccionado.hor_b1 !== "null" &&
                                usuarioSeleccionado.hor_b2 &&
                                usuarioSeleccionado.hor_b2 !== "null" &&
                                " - "}

                              {/* Mostrar hor_b2 solo si tiene un valor válido */}
                              {usuarioSeleccionado.hor_b2 &&
                                usuarioSeleccionado.hor_b2 !== "null" &&
                                usuarioSeleccionado.hor_b2}

                              {/* Mostrar separador si (hor_b1 O hor_b2 tienen valor) Y hor_b3 tiene valor */}
                              {((usuarioSeleccionado.hor_b1 &&
                                usuarioSeleccionado.hor_b1 !== "null") ||
                                (usuarioSeleccionado.hor_b2 &&
                                  usuarioSeleccionado.hor_b2 !== "null")) &&
                                usuarioSeleccionado.hor_b3 &&
                                usuarioSeleccionado.hor_b3 !== "null" &&
                                " - "}

                              {/* Mostrar hor_b3 solo si tiene un valor válido */}
                              {usuarioSeleccionado.hor_b3 &&
                                usuarioSeleccionado.hor_b3 !== "null" &&
                                usuarioSeleccionado.hor_b3}
                            </td>
                          </tr>
                        )}

                      {/* Fila C */}
                      {usuarioSeleccionado.mat_c1 &&
                        usuarioSeleccionado.mat_c1 !== "null" && (
                          <tr>
                            <td>{usuarioSeleccionado.mat_c1}</td>
                            <td>{usuarioSeleccionado.dias_c1}</td>
                            <td>
                              {usuarioSeleccionado.hor_c1 &&
                                usuarioSeleccionado.hor_c1 !== "null" &&
                                usuarioSeleccionado.hor_c1}
                              {usuarioSeleccionado.hor_c1 &&
                                usuarioSeleccionado.hor_c1 !== "null" &&
                                usuarioSeleccionado.hor_c2 &&
                                usuarioSeleccionado.hor_c2 !== "null" &&
                                " - "}
                              {usuarioSeleccionado.hor_c2 &&
                                usuarioSeleccionado.hor_c2 !== "null" &&
                                usuarioSeleccionado.hor_c2}
                              {((usuarioSeleccionado.hor_c1 &&
                                usuarioSeleccionado.hor_c1 !== "null") ||
                                (usuarioSeleccionado.hor_c2 &&
                                  usuarioSeleccionado.hor_c2 !== "null")) &&
                                usuarioSeleccionado.hor_c3 &&
                                usuarioSeleccionado.hor_c3 !== "null" &&
                                " - "}
                              {usuarioSeleccionado.hor_c3 &&
                                usuarioSeleccionado.hor_c3 !== "null" &&
                                usuarioSeleccionado.hor_c3}
                            </td>
                          </tr>
                        )}

                      {/* Fila D */}
                      {usuarioSeleccionado.mat_d1 &&
                        usuarioSeleccionado.mat_d1 !== "null" && (
                          <tr>
                            <td>{usuarioSeleccionado.mat_d1}</td>
                            <td>{usuarioSeleccionado.dias_d1}</td>
                            <td>
                              {usuarioSeleccionado.hor_d1 &&
                                usuarioSeleccionado.hor_d1 !== "null" &&
                                usuarioSeleccionado.hor_d1}
                              {usuarioSeleccionado.hor_d1 &&
                                usuarioSeleccionado.hor_d1 !== "null" &&
                                usuarioSeleccionado.hor_d2 &&
                                usuarioSeleccionado.hor_d2 !== "null" &&
                                " - "}
                              {usuarioSeleccionado.hor_d2 &&
                                usuarioSeleccionado.hor_d2 !== "null" &&
                                usuarioSeleccionado.hor_d2}
                              {((usuarioSeleccionado.hor_d1 &&
                                usuarioSeleccionado.hor_d1 !== "null") ||
                                (usuarioSeleccionado.hor_d2 &&
                                  usuarioSeleccionado.hor_d2 !== "null")) &&
                                usuarioSeleccionado.hor_d3 &&
                                usuarioSeleccionado.hor_d3 !== "null" &&
                                " - "}
                              {usuarioSeleccionado.hor_d3 &&
                                usuarioSeleccionado.hor_d3 !== "null" &&
                                usuarioSeleccionado.hor_d3}
                            </td>
                          </tr>
                        )}

                      {/* Fila E */}
                      {usuarioSeleccionado.mat_e1 &&
                        usuarioSeleccionado.mat_e1 !== "null" && (
                          <tr>
                            <td>{usuarioSeleccionado.mat_e1}</td>
                            <td>{usuarioSeleccionado.dias_e1}</td>
                            <td>
                              {usuarioSeleccionado.hor_e1 &&
                                usuarioSeleccionado.hor_e1 !== "null" &&
                                usuarioSeleccionado.hor_e1}
                              {usuarioSeleccionado.hor_e1 &&
                                usuarioSeleccionado.hor_e1 !== "null" &&
                                usuarioSeleccionado.hor_e2 &&
                                usuarioSeleccionado.hor_e2 !== "null" &&
                                " - "}
                              {usuarioSeleccionado.hor_e2 &&
                                usuarioSeleccionado.hor_e2 !== "null" &&
                                usuarioSeleccionado.hor_e2}
                              {((usuarioSeleccionado.hor_e1 &&
                                usuarioSeleccionado.hor_e1 !== "null") ||
                                (usuarioSeleccionado.hor_e2 &&
                                  usuarioSeleccionado.hor_e2 !== "null")) &&
                                usuarioSeleccionado.hor_e3 &&
                                usuarioSeleccionado.hor_e3 !== "null" &&
                                " - "}
                              {usuarioSeleccionado.hor_e3 &&
                                usuarioSeleccionado.hor_e3 !== "null" &&
                                usuarioSeleccionado.hor_e3}
                            </td>
                          </tr>
                        )}

                      {/* Fila F */}
                      {usuarioSeleccionado.mat_f1 &&
                        usuarioSeleccionado.mat_f1 !== "null" && (
                          <tr>
                            <td>{usuarioSeleccionado.mat_f1}</td>
                            <td>{usuarioSeleccionado.dias_f1}</td>
                            <td>
                              {usuarioSeleccionado.hor_f1 &&
                                usuarioSeleccionado.hor_f1 !== "null" &&
                                usuarioSeleccionado.hor_f1}
                              {usuarioSeleccionado.hor_f1 &&
                                usuarioSeleccionado.hor_f1 !== "null" &&
                                usuarioSeleccionado.hor_f2 &&
                                usuarioSeleccionado.hor_f2 !== "null" &&
                                " - "}
                              {usuarioSeleccionado.hor_f2 &&
                                usuarioSeleccionado.hor_f2 !== "null" &&
                                usuarioSeleccionado.hor_f2}
                              {((usuarioSeleccionado.hor_f1 &&
                                usuarioSeleccionado.hor_f1 !== "null") ||
                                (usuarioSeleccionado.hor_f2 &&
                                  usuarioSeleccionado.hor_f2 !== "null")) &&
                                usuarioSeleccionado.hor_f3 &&
                                usuarioSeleccionado.hor_f3 !== "null" &&
                                " - "}
                              {usuarioSeleccionado.hor_f3 &&
                                usuarioSeleccionado.hor_f3 !== "null" &&
                                usuarioSeleccionado.hor_f3}
                            </td>
                          </tr>
                        )}

                      {/* Fila G */}
                      {usuarioSeleccionado.mat_g1 &&
                        usuarioSeleccionado.mat_g1 !== "null" && (
                          <tr>
                            <td>{usuarioSeleccionado.mat_g1}</td>
                            <td>{usuarioSeleccionado.dias_g1}</td>
                            <td>
                              {usuarioSeleccionado.hor_g1 &&
                                usuarioSeleccionado.hor_g1 !== "null" &&
                                usuarioSeleccionado.hor_g1}
                              {usuarioSeleccionado.hor_g1 &&
                                usuarioSeleccionado.hor_g1 !== "null" &&
                                usuarioSeleccionado.hor_g2 &&
                                usuarioSeleccionado.hor_g2 !== "null" &&
                                " - "}
                              {usuarioSeleccionado.hor_g2 &&
                                usuarioSeleccionado.hor_g2 !== "null" &&
                                usuarioSeleccionado.hor_g2}
                              {((usuarioSeleccionado.hor_g1 &&
                                usuarioSeleccionado.hor_g1 !== "null") ||
                                (usuarioSeleccionado.hor_g2 &&
                                  usuarioSeleccionado.hor_g2 !== "null")) &&
                                usuarioSeleccionado.hor_g3 &&
                                usuarioSeleccionado.hor_g3 !== "null" &&
                                " - "}
                              {usuarioSeleccionado.hor_g3 &&
                                usuarioSeleccionado.hor_g3 !== "null" &&
                                usuarioSeleccionado.hor_g3}
                            </td>
                          </tr>
                        )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Container>
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={() => handleVerClick(usuarioSeleccionado)}
            >
              Ver Completo
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalVerPerfil()}
            >
              Cerrar
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal añadir usuario */}
        <Modal isOpen={modalInsertar} toggle={abrirCerrarModalInsertar}>
          <ModalHeader className="header_mo" close={closeBtnA}>
            Insertar Usuario
          </ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label>Nombres: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="nombre"
                  value={usuarioSeleccionado.nombre}
                  onChange={handleChange}
                />
                {!isValid.nombre && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Apellidos: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="apellido"
                  value={usuarioSeleccionado.apellido}
                  onChange={handleChange}
                />
                {!isValid.apellido && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Id Usuario: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="id_bec"
                  value={usuarioSeleccionado.id_bec}
                  onChange={handleChange}
                />
                {!isValid.id_bec && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Año Ingreso BQEF: </Label>
                <Input
                  type="number"
                  className="form-control"
                  name="anio_ing_bqef"
                  value={usuarioSeleccionado.anio_ing_bqef}
                  onChange={handleChange}
                />
                {!isValid.anio_ing_bqef && (
                  <span style={{ color: "red" }}>Formato no válido</span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Estado Cuenta: </Label>
                <Input
                  type="select"
                  className="form-control"
                  name="estado"
                  value={usuarioSeleccionado.estado}
                  onChange={handleChange}
                >
                  <option value="">Seleccionar</option>{" "}
                  {/* Opción por defecto */}
                  <option value="activo">Activo</option>
                  <option value="bloqueado">Bloqueado</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Correo: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="email"
                  value={usuarioSeleccionado.email}
                  onChange={handleChange}
                />
                {!isValid.email && (
                  <span style={{ color: "red" }}>Correo no válido</span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Clave: </Label>
                <div style={{ position: "relative" }}>
                  <Input
                    type={mostrarContrasena ? "text" : "password"}
                    className="form-control"
                    name="contrasena_lit"
                    value={usuarioSeleccionado.contrasena_lit}
                    onChange={handleChange}
                  />
                  {/* Icono para mostrar/ocultar */}
                  <span
                    onClick={toggleMostrarContrasena}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  >
                    {mostrarContrasena ? (
                      <FaIcons.FaEyeSlash /> // icono de ocultar
                    ) : (
                      <FaIcons.FaEye /> // icono de mostrar
                    )}
                  </span>
                </div>
                {!isValid.contrasena_lit && (
                  <span style={{ color: "red" }}>
                    La contraseña debe tener al menos 8 caracteres, incluyendo
                    mayúsculas, minúsculas, números y caracteres especiales
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Celular: </Label>
                <Input
                  type="number"
                  className="form-control"
                  name="celular"
                  value={usuarioSeleccionado.celular}
                  onChange={handleChange}
                />
                {!isValid.celular && (
                  <span style={{ color: "red" }}>Número celular no válido</span>
                )}
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={(e) => peticionPost(e)}
              disabled={
                !isValid.nombre ||
                !isValid.apellido ||
                !isValid.id_bec ||
                !isValid.email ||
                !isValid.celular ||
                !isValid.contrasena_lit
              }
            >
              Guardar
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalInsertar()}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal Editar */}
        <Modal isOpen={modalEditar} toggle={abrirCerrarModalEditar}>
          <ModalHeader className="header_mo">Modificar Usuario</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label>
                  Nombres:{usuarioSeleccionado && usuarioSeleccionado.id_bec}
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="nombre"
                  onChange={handleChange}
                  value={usuarioSeleccionado && usuarioSeleccionado.nombre}
                />
                {!isValid.nombre && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Apellidos: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="apellido"
                  onChange={handleChange}
                  value={usuarioSeleccionado && usuarioSeleccionado.apellido}
                />
                {!isValid.apellido && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Correo: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="email"
                  onChange={handleChange}
                  value={usuarioSeleccionado && usuarioSeleccionado.email}
                />
                {!isValid.email && (
                  <span style={{ color: "red" }}>Correo no válido</span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Clave: </Label>
                <div style={{ position: "relative" }}>
                  <Input
                    type={mostrarContrasena ? "text" : "password"}
                    className="form-control"
                    name="contrasena_lit"
                    onChange={handleChange}
                    value={
                      usuarioSeleccionado && usuarioSeleccionado.contrasena_lit
                    }
                  />
                  <span
                    onClick={toggleMostrarContrasena}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  >
                    {mostrarContrasena ? (
                      <FaIcons.FaEyeSlash />
                    ) : (
                      <FaIcons.FaEye />
                    )}
                  </span>
                </div>
                {!isValid.contrasena_lit && (
                  <span style={{ color: "red" }}>
                    La contraseña debe tener al menos 8 caracteres, incluyendo
                    mayúsculas, minúsculas, números y caracteres especiales
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Celular: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="celular"
                  onChange={handleChange}
                  value={usuarioSeleccionado && usuarioSeleccionado.celular}
                />
                {!isValid.celular && (
                  <span style={{ color: "red" }}>Número celular no válido</span>
                )}
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={() => peticionPut()}
              disabled={
                !isValid.nombre ||
                !isValid.apellido ||
                !isValid.id_bec ||
                !isValid.email ||
                !isValid.celular ||
                !isValid.contrasena_lit
              }
            >
              Editar
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalEditar()}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal Eliminar Usuario*/}
        <Modal isOpen={modalEliminar} toggle={abrirCerrarModalEliminar}>
          <ModalHeader className="header_mo">Eliminar Becario</ModalHeader>
          <ModalBody>
            ¿Estás seguro que deseas eliminar el Usuario{" "}
            {usuarioSeleccionado && usuarioSeleccionado.nombre}?
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={() => peticionDelete(usuarioSeleccionado.id_bec)}
            >
              Sí
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalEliminar()}
            >
              No
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal VER REPORTE CUENTAS BECARIOS*/}
        <Modal isOpen={modalVerNot} toggle={abrirCerrarModalVerNot} size="lg">
          <ModalHeader className="header_mo" close={closeBtn2}>
            Estado Académico Becarios
          </ModalHeader>
          <ModalBody>
            <Button color="primary" size="lg" onClick={generatePDFN}>
              <FaIcons.FaFileDownload /> Reporte
            </Button>
            <hr></hr>
            <Input
              type="select"
              className="form-control"
              onChange={handleSelectUser}
              value={selectedUser}
            >
              <option value="">Seleccione becario</option>
              {uniqueUsers
                .sort((a, b) => (a.nombre ?? "").localeCompare(b.nombre ?? ""))
                .map((user, index) => (
                  <option key={user.id_bec} value={user.id_bec}>
                    {index + 1}. {user.nombre} {user.apellido}
                  </option>
                ))}
            </Input>
            <hr></hr>
            <Table id="tabl">
              <thead id="stahead">
                <tr className="text-center">
                  <th>N°</th>
                  <th>Nombre Becario</th>
                  <th>N. Académica</th>
                  <th>Gestión</th>
                  <th>Semestre</th>
                  <th>N. Evaluación</th>
                </tr>
              </thead>
              {/* Tabla con datos filtrados */}
              <tbody>
                {filteredNotas
                  .filter((iteb) => iteb.semestre && iteb.semestre !== "null")
                  .map((iteb, index) => (
                    <tr key={iteb.id_bec + index} className="text-center">
                      <td>{index + 1}</td>
                      <td>
                        {iteb.nombre} {iteb.apellido}
                      </td>
                      <td>{iteb.promedio_semestre ?? "N/A"}</td>
                      <td>{iteb.anio ?? "N/A"}</td>
                      <td>{iteb.semestre ?? "N/A"}</td>
                      <td>{iteb.nota_eva ?? "N/A"}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
            <Card body>
              {/* Gráfico de línea */}
              <div
                id="chartContainer"
                style={{ width: "100%", height: "400px" }}
              >
                <Line data={datosNotas} options={opcionesNotas} />
              </div>
            </Card>
          </ModalBody>
        </Modal>
        {/* Modal Graduar Usuario*/}
        <Modal isOpen={modalGraduado} toggle={abrirCerrarModalGraduado}>
          <ModalHeader className="header_mo">Graduar Becario</ModalHeader>
          <ModalBody>
            ¿Estás seguro que deseas realizar la operación para el usuario:{" "}
            {usuarioSeleccionado && usuarioSeleccionado.nombre}?
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={() => peticionGrad(usuarioSeleccionado.id_bec)}
            >
              Sí
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalGraduado()}
            >
              No
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}

export default ListUser;
